import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
interface EspaceContextValue {
  /** Vrai quand le citoyen navigue dans « Mon espace » (barre latérale affichée). */
  inEspace: boolean;
  enterEspace: () => void;
  exitEspace: () => void;
}
const EspaceContext = createContext<EspaceContextValue>({
  inEspace: false,
  enterEspace: () => {},
  exitEspace: () => {}
});

/** Permet d'ouvrir un module directement dans « Mon espace » via ?espace=1. */
function espaceFromUrl(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('espace') === '1';
}
export function EspaceProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [inEspace, setInEspace] = useState(espaceFromUrl);
  const enterEspace = useCallback(() => setInEspace(true), []);
  const exitEspace = useCallback(() => setInEspace(false), []);
  const value = useMemo(() => ({
    inEspace,
    enterEspace,
    exitEspace
  }), [inEspace, enterEspace, exitEspace]);
  return <EspaceContext.Provider value={value} data-id="element-2872" data-mp="e0r9vxxrtcle">{children}</EspaceContext.Provider>;
}
export function useEspace(): EspaceContextValue {
  return useContext(EspaceContext);
}